import { NUM_INDEXABLE_PAGES } from '../constants';

export default function mustBePreviousPageIndexed(currentPage) {
  return currentPage <= NUM_INDEXABLE_PAGES + 1;
}



// WEBPACK FOOTER //
// ./app/Serp/components/shared/Pager/utils/mustBePreviousPageIndexed.js